import { parseCookies } from 'nookies'
import { logger } from '@moonpig/web-core-monitoring'
import { CookieCategory } from './CookieCategory'

const checkConsent = (
  category: CookieCategory,
  suppressErrorIfNoCookie: boolean,
): boolean => {
  const cookies = parseCookies()
  const oneTrustCookie = cookies.OptanonConsent
  if (!oneTrustCookie) {
    if (!suppressErrorIfNoCookie) {
      logger.fixToday(
        'Attempting to check consent for non-essential cookie before banner has been interacted with.',
      )
    }
    return false
  }

  const consentGroup = `${category}:1`
  return oneTrustCookie.includes(consentGroup)
}

export const hasConsentForCategory = (
  category: CookieCategory,
  suppressErrorIfNoCookie = false,
): boolean => {
  return (
    category === CookieCategory.STRICTLY_NECESSARY ||
    checkConsent(category, suppressErrorIfNoCookie)
  )
}
